import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Hidden, Modal } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./navbar.module.css";
import MenuIcon from "@material-ui/icons/Menu";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    background:
      "linear-gradient(45deg,rgba(150,0,240,0.8) 50%, rgba(0,0,0,0.3) 50%)",
    height: "60px",
    width: "100%",
  },
  bar: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
    alignItems: "center",
  },
  title: {
    color: "white",
    fontWeight: "bold",
    fontSize: "calc(1em + 2vw)",
    maxWidth: "40vw",
    //fontFamily: "'Yusei Magic', sans-serif"
  },
}));

export default function Navbar({ toggle }) {
  const classes = useStyles();
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState("KARLO SOBERÓN")
  const switchModal = (e) => {
    e?.target?.name && setTitle(e.target.name)
    setModal(!modal);
  };
  return (
    <>
    <AppBar className={classes.root}>
      <Toolbar className={classes.bar}>
        <a href="#main" onClick={()=>setTitle('KARLO SOBERÓN')} className={styles.title}>
          <Typography className={classes.title}>{title}</Typography>
        </a>
        <nav container className={styles.sections}>
          <Hidden smUp>
            <a
              href
              type="button"
              style={{ cursor: "pointer" }}
              onClick={switchModal}
            >
              <MenuIcon />
            </a>
          </Hidden>
          <Hidden xsDown>
            <Typography variant="h5">
              <a href="#main" onClick={()=>setTitle('KARLO SOBERÓN')}>Me</a>
            </Typography>
            <Typography variant="h5">
              <a href="#skills" onClick={()=>setTitle('SKILLS')}>Skills</a>
            </Typography>
            <Typography variant="h5">
              <a href="#projects" onClick={()=>setTitle('PROJECTS')}>Projects</a>
            </Typography>
            <Typography variant="h5">
              <a
                href
                type="button"
                style={{ cursor: "pointer" }}
                onClick={toggle}
              >
                Contact
              </a>
            </Typography>
          </Hidden>
        </nav>
      </Toolbar>
    </AppBar>
    <Modal open={modal} onClose={switchModal}>
    <div className={styles.modal}>
      <Typography variant="h5">
        <a href="#main" name='KARLO SOBERÓN' onClick={switchModal}>
          Me
        </a>
      </Typography>
      <Typography variant="h5">
        <a href="#skills" name='SKILLS' onClick={switchModal}>
          Skills
        </a>
      </Typography>
      <Typography variant="h5">
        <a href="#projects" name='PROJECTS' onClick={switchModal}>
          Projects
        </a>
      </Typography>
      <Typography variant="h5">
        <a
          href
          type="button"
          style={{ cursor: "pointer" }}
          onClick={() => {
            toggle();
            switchModal();
          }}
        >
          Contact
        </a>
      </Typography>
    </div>
  </Modal>
  </>
  );
}
